import React, { Component } from "react";
import "../App.css";
import "../Style/General.css";
import "../Style/Summary.css";
import Description from "./Description.js";
import { Panel } from "react-bootstrap";
import StatusBox from "../components/StatusBox";
import ViabilityBox from "../components/ViabilityBox";

//Description of this group.
//This is what user will see by pressing the info icon.
const description = (
  <div>
    This is the summary window, showing a collection of the most important
    search results and indicating the state of each result with both numbers and
    color.
  </div>
);

class Summary extends Component {
  constructor() {
    super();
    this.state = {
      trademarks: null,
      domains: null,
      twitter: null,
      facebook: null,
      instagram: null,
      open: true,
    };
  }

  addResult(source, content) {
    // Receive results from backend, and set
    // results into the state
    switch (source) {
      case "Trademarks":
        this.setState({ trademarks: content });
        break;
      case "Domains":
        this.setState({ domains: content });
        break;
      case "Twitter":
        this.setState({ twitter: content });
        break;
      case "Facebook":
        this.setState({ facebook: content });
        break;
      case "Instagram":
        this.setState({ instagram: content });
        break;
      default:
        break;
    }
  }

  clear() {
    // This is not needed here anymore, but is called from
    // parent, so need to keep it here.
  }

  // 0 green, 100 red
  getColor(n) {
    var R = parseInt((255 * n) / 100, 10);
    var G = parseInt((255 * (100 - n)) / 100, 10);
    G = Math.min(G, 200);
    var B = 0;
    return `rgb(${R.toString()}, ${G.toString()}, ${B.toString()})`;
  }

  // Number of identical trademarks
  getIdenticalTrademarks() {
    try {
      let identical = 0;
      this.state.trademarks[0].data.forEach((trademark) => {
        if (trademark.similarity === 1) {
          identical++;
        }
      });
      return identical;
    } catch (error) {
      console.error("Error while counting identical trademarks.", error);
      return null;
    }
  }

  // Number of similar trademarks
  getSimilarTrademarks() {
    try {
      const similar = this.state.trademarks[0].data.length;
      return similar;
    } catch (error) {
      console.error("Error while counting similar trademarks.", error);
      return null;
    }
  }

  getIdenticalTrademarksReduction() {
    // Count identical trademarks
    const identical = this.getIdenticalTrademarks();
    // If error happens, handle it as the worst scenario,
    // so reduce the max amount (40)
    if (identical === null) {
      return 40;
    }
    // Calculate reduction
    else if (identical === 1) {
      return 25;
    } else if (identical >= 2) {
      return 40;
    } else {
      return 0;
    }
  }

  getSimilarTrademarksReduction() {
    // Count similar trademarks
    const similar = this.getSimilarTrademarks();
    // If error happens, handle it as the worst scenario,
    // so reduce the max amount (12)
    if (similar === null) {
      return 12;
    }
    // Calculate reduction
    if (similar >= 30) {
      return 12;
    } else if (similar >= 20) {
      return 8;
    } else if (similar >= 10) {
      return 4;
    } else {
      return 0;
    }
  }

  getTrademarksColor() {
    const similarReduction = this.getSimilarTrademarksReduction();
    const identicalReduction = this.getIdenticalTrademarksReduction();
    const totalPossibleReduction = 40 + 12;
    return this.getColor(
      ((similarReduction + identicalReduction) / totalPossibleReduction) * 100
    );
  }

  // Number of active websites
  getActiveWebsites() {
    try {
      let taken = 0;
      this.state.domains.forEach((domain) => {
        if (domain.available[0] === "Taken") {
          taken++;
        }
      });
      return taken;
    } catch (error) {
      console.error("Error while counting active websites.", error);
      return null;
    }
  }

  // Total number of websites
  getTotalWebsites() {
    return Array.isArray(this.state.domains) && this.state.domains.length;
  }

  getActiveWebsitesStatus() {
    const total = this.getTotalWebsites();
    const active = this.getActiveWebsites();
    return `${active}/${total}`;
  }

  getActiveWebsitesReduction() {
    // Count similar trademarks
    const taken = this.getActiveWebsites();
    // Calculate reduction
    if (taken >= 8) {
      return 15;
    } else if (taken >= 4) {
      return 10;
    } else {
      return 0;
    }
  }

  getActiveWebsitesColor() {
    const active = this.getActiveWebsites();
    const total = this.getTotalWebsites();
    return this.getColor((active / total) * 100);
  }

  getTotalSocialMediaAccounts() {
    let total = 3;
    if(this.state.instagram[0] === "error") {
      total = 2
    }
    return total
  }

  getTakenSocialMediaAccounts() {
    let taken = 0;
    ["twitter", "facebook", "instagram"].forEach((key) => {
      if (
        Array.isArray(this.state[key]) &&
        this.state[key].length > 0 &&
        this.state[key][0] === "TAKEN"
      ) {
        taken++;
      }
    });
    return taken;
  }

  getSocialMediaReduction() {
    // Count taken social media accounts
    // Special handling for instagram in case its inconclusive
    const taken = this.getTakenSocialMediaAccounts();
    const total = this.getTotalSocialMediaAccounts();

    if(total === 3) {
      switch (taken) {
        case 1:
          return 5;
        case 2:
          return 10;
        case 3:
          return 30;
        default:
          return 0;
      }
    }

    if(total === 2) {
      switch (taken) {
        case 1:
          return 10;
        case 2:
          return 30;
        default:
          return 0;
      }
    }

  }

  getSocialMediaColor() {
    const taken = this.getTakenSocialMediaAccounts();
    const total = this.getTotalSocialMediaAccounts();
    return this.getColor((taken / total) * 100);
  }

  getViabilityScore() {
    // Check if all required values are available
    if (
      this.state.trademarks &&
      this.state.domains &&
      this.state.twitter &&
      this.state.facebook &&
      this.state.instagram
    ) {
      // Get values needed for score calculation
      const identicalTrademarksReduction = this.getIdenticalTrademarksReduction();
      const similarTrademarksReduction = this.getSimilarTrademarksReduction();
      const activeWebsitesReduction = this.getActiveWebsitesReduction();
      const socialMediaReduction = this.getSocialMediaReduction();

      // Debug helper
      if (localStorage.getItem("debug")) {
        console.log("Current state:");
        console.log(this.state);

        console.log("Viability score:");
        console.log("100");
        console.log(
          `-${identicalTrademarksReduction} (identical trademarks - ${this.getIdenticalTrademarks()})`
        );
        console.log(
          `-${similarTrademarksReduction} (similar trademarks - ${this.getSimilarTrademarks()})`
        );
        console.log(
          `-${activeWebsitesReduction} (active websites - ${this.getActiveWebsitesStatus()})`
        );
        console.log(
          `-${socialMediaReduction} (taken social media accounts - ${this.getTakenSocialMediaAccounts()})`
        );
      }

      // Calculate and return the viability score.
      // Start from 100% and reduce from there
      return (
        100 -
        identicalTrademarksReduction -
        similarTrademarksReduction -
        activeWebsitesReduction -
        socialMediaReduction
      );
    }
    // Else return null
    else {
      return null;
    }
  }

  handleClick() {
    this.setState({ open: !this.state.open });
  }

  header(ready) {
    return (
      <div
        className="resultBox__header"
        onClick={() => this.setState({ open: !this.state.open })}
      >
        <div className="resultBox__title">Summary</div>
      </div>
    );
  }

  render() {
    const viabilityScore = this.getViabilityScore();
    const loading = !viabilityScore;

    const trademarksLoading = this.state.trademarks === null;
    const someLoading =
      this.state.twitter === null ||
      this.state.facebook === null ||
      this.state.instagram === null;
    const domainsLoading = this.state.domains === null;

    return (
      <Panel
        className="resultBox"
        collapsible
        expanded={this.state.open}
        header={this.header(!loading)}
      >
        <div className="resultBox__content clearfix">
          <div className="Description summary">{description}</div>
          <div className="summary_panel">
            <div id="risks_div">
              <ViabilityBox
                loading={loading}
                viability={viabilityScore}
                color={this.getColor(100 - viabilityScore)}
              />
            </div>
            <div id="summary_div">
              <StatusBox
                type="TRADEMARKS"
                loading={trademarksLoading}
                color={trademarksLoading ? "" : this.getTrademarksColor()}
                title={"Trademarks"}
                info={[
                  trademarksLoading ? "" : this.getIdenticalTrademarks(),
                  "Identical",
                  trademarksLoading ? "" : this.getSimilarTrademarks(),
                  "Similar",
                ]}
                id="trademarks-box"
              />
              <StatusBox
                type="SOCIAL_MEDIA"
                loading={someLoading}
                color={someLoading ? "" : this.getSocialMediaColor()}
                title={"Social Media"}
                info={[
                  someLoading ? "" : this.getTakenSocialMediaAccounts() + "/" + this.getTotalSocialMediaAccounts(),
                  "Taken",
                ]}
                id="smpanel"
              />
              <StatusBox
                type="DOMAINS"
                loading={domainsLoading}
                color={domainsLoading ? "" : this.getActiveWebsitesColor()}
                title={"Active Websites"}
                info={[
                  domainsLoading ? "" : this.getActiveWebsitesStatus(),
                  "Domains point to active websites",
                ]}
                id="domainpanel"
              />
            </div>
          </div>
        </div>

        <div className="resultBox__footer">
          <div className="hide__help">
            <div className="resultBox__help">
              <Description description={description} />
              <p>What is this report about?</p>
            </div>
          </div>
          <div className="infopurp">
            The scores and results in this report are for guidance only and are not legal advice.
            Should you require legal advice please contact our legal partner.{" "}
            <a 
              href="https://www.searchabrand.com/legal-advice" 
              target="_blank" 
              rel="noopener noreferrer"
              className="infopurp__link"
            >
              Send a message
            </a>
          </div>
        </div>
      </Panel>
    );
  }
}

export default Summary;



// WEBPACK FOOTER //
// ./client/src/Groups/Summary.js